export enum ZissonInteractCategoryChangeStatus {
    none = 0,
    allowedWithoutRestrictions = 1,
    allowedWithWarning = 2,
    notAllowed = 3,
}
